module.exports = __webpack_public_path__ + "static/media/movemetns.74f5fe49.ogg";